<template>
  <div style="min-width:750px;" class="ml-10 mr-5 mt-5">
    <p style="font-size:24px;font-weight:bold;">内容创作</p>
    <div style="display:flex;flex-flow: wrap; " class="mt-4">
      <div @click="intoCreatePage(item)" v-for="(item,index) in createList1" :key="index" :style="{'margin-right':index !== createList1.length-1 ? '70px' : '0'}" class="createItem">
        <div :style="{'background-image':'url(' + item.thumbSrc + ')'}"
             style="width:60px;height:84px;margin:59px auto 40px auto;background-size:contain;background-position: center;">
        </div>
        <p>{{item.title}}</p>
      </div>


    </div>
<!--    <p style="font-size:24px;font-weight:bold;">共生应用</p>-->

  </div>
</template>

<script>
import articleThumb from '/src/assets/main_create/article.png'
import videoThumb from '/src/assets/main_create/video.png'
export default {
  name: "MainCreate",
  data(){
    return{
      createList1:[
        {thumbSrc:articleThumb,title:"长图文创作",href:"/createArticle"},
        {thumbSrc:videoThumb,title:"视频创作",href:"/createVideo"}
      ]


    }
  },
  methods:{
    intoCreatePage(item){
      let route = this.$router.resolve({
        path: item.href
      });
      window.open(route.href, '_blank');
    }

  }

}
</script>

<style scoped>
.createItem{
  width:200px;
  height:250px;
  background:#ffffff;
  border-radius:3px;
  border:2px solid transparent;
  text-align:center;
  font-size:16px;
}
.createItem:hover{
  border-color:#1976D2;
}

</style>